import { useSelector } from "react-redux";
import { getScreenMedia } from "selectors";

export const useMediaSize = () => {
  const media = useSelector(getScreenMedia);

  return media;
};
